import PropTypes from 'prop-types'
import React from 'react'
import {
  ListItem
} from 'components/List'
import classes from './ElementItem.module.scss'

export class ElementItem extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    hoverable: PropTypes.bool,
    inverted: PropTypes.bool,
    onClick: PropTypes.func
  }

  static defaultProps = {
    component: ListItem,
  }

  render () {
    const {
      component: Component,
      className,
      hoverable,
      inverted,
      onClick,

      ...restProps
    } = this.props

    let compClassName = classes.elementItem
    if (className) compClassName += ' ' + className
    if (inverted)  compClassName += ' ' + classes.inverted
    if (onClick || hoverable) compClassName += ' ' + classes.clickable
    
    return (
      <Component
        {...restProps}
        className={compClassName}
        onClick={onClick}
      />
    )
  }
}

export default ElementItem

